import "../css/NavBar.css";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";

const NavBar = () => {
  const [scrollTop, setScrollTop] = useState(0);
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setScrollTop(window.pageYOffset);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handlePageClick = (page) => {
    navigate(page);
    setMenuOpen(false); // close menu on nav
  };

  const handleBookingClick = () => {
    window.open("https://lin.ee/uNosyZb", "_blank", "noopener,noreferrer");
    setMenuOpen(false);
  };

  return (
    <div className={`topDiv ${scrollTop > 0 ? "shrink" : ""}`}>
      <div className="navInner">

        {/* LEFT: Logo */}
        {/*<div className="leftGroup">

        </div>*/}

        {/* CENTER: Links */}
        {/*<div className={`navLinks ${menuOpen ? "active" : ""}`}>
            <img 
                src="/assets/homepage/slimeville_logo_pink.png" 
                style={{height:"80%", cursor:"pointer"}}
                onClick={()=>handlePageClick("/")}
            />
        </div>*/}

        <img 
            src="/assets/homepage/slimeville_logo_pink.png" 
            style={{height:"50%", cursor:"pointer"}}
            onClick={()=>handlePageClick("/")}
        />

        {/* RIGHT: Actions */}
        {/*<div className="rightGroup">
          <button
            className={`hamburger ${menuOpen ? "open" : ""}`}
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Menu"
          >
            <span></span><span></span><span></span>
          </button>
        </div>*/}
      </div>
    </div>
  );
};

export default NavBar;
